const formatCompletionRate = (rate: number): string => {
  if (!Number.isFinite(rate)) return '0%';
  const asPercent = rate > 0 && rate <= 1 ? rate * 100 : rate;
  const rounded = Math.round(asPercent * 10) / 10;
  return `${rounded}%`;
};

export default formatCompletionRate;
